// AppShellHost — module-level inline style objects.
//
// Extracted verbatim from AppShellHost.tsx (C1 decomposition). Static
// presentation constants (no component state), imported back by the shell and
// the extracted render sub-components.

import type { CSSProperties } from "react";

export const centeredStyle: CSSProperties = {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "var(--space-8)",
};

// The ONE legitimate full-screen failure (audit D1): a calm, recoverable column
// — a labelled heading, human body, one guaranteed action. Reading-measured so
// the copy never sprawls; centred by `centeredStyle`.
export const bootFailureColumnStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: "var(--space-3)",
    maxWidth: "var(--measure-reading)",
};

// A pane crash-fallback's two actions (Retry + optional Close), a tight row.
export const paneFallbackActionsStyle: CSSProperties = {
    display: "flex",
    gap: "var(--space-2)",
};

// The keep-shell boot/session banner (audit D1): a terminal error that arrives
// with a loaded shell floats HERE — pinned top-centre OVER a still-usable shell
// — instead of replacing it. So a mid-session 401 offers re-auth without
// throwing away the workspace.
export const bootBannerOverlayStyle: CSSProperties = {
    position: "fixed",
    insetBlockStart: "var(--space-3)",
    insetInline: 0,
    display: "flex",
    justifyContent: "center",
    padding: "0 var(--space-4)",
    zIndex: "var(--z-overlay)",
    pointerEvents: "none",
};
